import config from '../../config/config';
import { DEFAULT_PAGE_SIZE } from '../components/ImageList';
import { getStore } from '../../store';
import { rendererHeaders } from '../helpers/app-services/AppServices/index';
import { rateLimitedfetch } from '../helpers/requestLimiter';

const { LIBRARY_API_DOMAIN } = config;

export const fetchWithApiToken = (path, spkToken, method = 'GET', headers = {}, body) => {
  if (spkToken) {
    headers['x-spk-auth-token'] = spkToken;
  }
  return rateLimitedfetch(`${LIBRARY_API_DOMAIN}${path}`, {
    method,
    headers: { ...headers },
    body: JSON.stringify(body)
  }).then(res => res.json());
};

export const getImageLibraries = spkToken => {
  return fetchWithApiToken('/api/libraries', spkToken);
};

export const getImageLibrary = (libraryId, spkToken, cursor = 0) => {
  return fetchWithApiToken(
    `/api/library/${libraryId}?cursor=${cursor}&pageSize=${DEFAULT_PAGE_SIZE}`,
    spkToken,
    'GET',
    {
      Accept: 'application/json'
    }
  );
};

export const getImageById = (id, thumb = false) => {
  const { auth } = getStore().getState();
  const { token: spkToken } = auth.currentUser;
  const headers = rendererHeaders(true);

  return fetchWithApiToken(`/api/library/image/${id}`, spkToken, 'GET', headers).then(res => {
    const { data } = res;
    return `${data.bucketUrl}/${thumb ? data.thumbnailFilename : data.imageFilename}`;
  });
};

export const searchImageLibrary = (search, spkToken, offset = 0) => {
  const query = search
    .trim()
    .split(/[^a-zA-Z0-9]+(?:'\w+)?/)
    .filter(n => n);
  return fetchWithApiToken(
    '/api/image/search',
    spkToken,
    'POST',
    {
      'Content-Type': 'application/json'
    },
    {
      searchTerms: query,
      limit: DEFAULT_PAGE_SIZE,
      excludeCommex: true,
      offset
    }
  );
};
